import Container from 'react-bootstrap/Container'
import React, { useEffect, useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { FormControl, InputGroup, Form } from 'react-bootstrap'
import {
    MdEmail,
    MdHome,
    MdLocalPostOffice,
    MdLocationCity,
    MdLocationOn,
    MdLock,
    MdPerson,
    MdWork,
    MdErrorOutline,
    MdPhone,
    MdCardMembership,
    MdPhoneIphone,
    MdHelp,
} from 'react-icons/md'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { IoMdEye, IoMdEyeOff } from 'react-icons/io'
import Location from '../models/Location'
import Select, { components } from 'react-select'
import Spinner from 'react-bootstrap/Spinner'
import { FaAngleDown } from 'react-icons/fa'
import Button from 'react-bootstrap/Button'

import COUNTRIES_JSON from '../assets/countries/countries.json'
import Palette from '../Palette'
import Specialization from '../models/Specialization'
import Language from '../models/Language'
import Member from '../models/Member'
import Cities from '../util/CityData'
import Provinces from '../util/ProvinceData'
import Swal from 'sweetalert2'
import Alert from '../components/Alert'
import { useHistory } from 'react-router-dom'
import { FaMinus, FaPlus } from 'react-icons/all'
import IconButton from '@material-ui/core/IconButton'
import MomentUtils from '@date-io/moment'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import '../pages/css/register.css'
import Upload from '../models/Upload'
import moment from 'moment'
import { Radio } from '@material-ui/core'
import CustomDropzone from '../components/Reusable/CustomDropzone'


function TSNTermsAndConditionPage(props) {
    const history = useHistory()

    const DropdownIndicator = (props) => {
        return (
            components.DropdownIndicator && (
                <components.DropdownIndicator {...props}>
                    <FaAngleDown color={'grey'} />
                </components.DropdownIndicator>
            )
        )
    }

    return (
        <Container>
            <Row className="page-title">Syarat dan Ketentuan Pendaftaran</Row>

            <Row>
                <Col xl={12} lg={12} md={12} xs={12} className={'m-auto'}>
                    <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>Tes Sertifikasi Nasional Himpunan Penerjemah Indonesia 2025</div>
                    Syarat dan Ketentuan berikut mengatur pendaftaran diri Anda sebagai peserta Tes Sertifikasi Nasional Himpunan Penerjemah Indonesia (TSN HPI) 2025 yang diselenggarakan oleh Himpunan Penerjemah Indonesia (HPI). Dengan melakukan pendaftaran, Anda dianggap telah membaca, memahami, dan menyetujui seluruh ketentuan di bawah ini.<br/>
                    <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>1. Persyaratan Peserta</div>
                        Pendaftaran hanya terbuka bagi anggota aktif HPI dengan status keanggotaan Profesional atau Aspiran. HPI berhak melakukan verifikasi status keanggotaan peserta kapan pun selama proses pendaftaran dan pelaksanaan ujian berlangsung.<br/>
                    <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>2. Batas Waktu dan Biaya Pendaftaran</div>
                        Terdapat dua jenis batas waktu dan biaya pendaftaran di TSN HPI 2025:<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&bull; TSN HPI untuk Penerjemah dan Editor Terjemahan<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Batas Waktu Pendaftaran: 13 Juni 2025, pukul 23.59 WIB<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Biaya per Mata Uji: Rp2.000.000<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&bull; TSN HPI untuk Juru Bahasa<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Batas Waktu Pendaftaran: 20 Juni 2025, pukul 23.59 WIB<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Biaya per Mata Uji: Rp4.000.000<br/>
                    Pendaftaran dinyatakan sah apabila pembayaran telah diterima secara penuh sebelum batas waktu yang ditentukan.<br/>
                    <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>3. Platform Pendaftaran</div>
                        Platform pendaftaran, termasuk pembayaran biaya pendaftaran, TSN HPI 2025 adalah Sihapei. Calon peserta mendaftar dengan terlebih dahulu masuk ke akun Sihapei-nya sendiri. Pendaftaran dan pembayaran biaya pendaftaran di luar Sihapei tidak diterima.<br/>
                    <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>4. Kebijakan Pembatalan dan Pengembalian
                        Dana</div>
                        Peserta yang ingin membatalkan pendaftarannya dapat mengajukan permohonan tertulis melalui email sebelum batas waktu pendaftaran yang berlaku. Kebijakan pengembalian dana sebagai berikut:<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&bull; Pengembalian 50%: Untuk permohonan pembatalan yang diterima melalui surel Sekretariat HPI paling lambat pukul 23.59 WIB pada tanggal batas waktu pendaftaran masing-masing jenis ujian.<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&bull; Tanpa Pengembalian Dana: Untuk permohonan pembatalan yang diterima setelah batas waktu pendaftaran masing-masing jenis ujian.<br/>
                    Proses pengembalian dana akan dilakukan dalam waktu maksimal 14 (empat belas) hari kerja setelah permohonan disetujui dengan metode transfer bank. Sekretariat HPI akan menghubungi calon peserta melalui surel untuk keperluan ini.<br/>
                    <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>5. Jadwal Ujian dan Penjadwalan Ulang</div>
                        Jadwal ujian telah ditentukan dan tidak dapat diubah. Tidak ada kebijakan penjadwalan ulang dalam bentuk apa pun.<br/>
                    <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>6. Keputusan Hasil Ujian</div>
                        Hasil ujian yang dikeluarkan oleh HPI bersifat final dan mengikat. Tidak tersedia mekanisme banding, sanggahan, atau permintaan peninjauan ulang.<br/>
                    <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>7. Kode Etik Peserta</div>
                        Seluruh peserta ujian wajib menjaga integritas profesional dan mematuhi kode etik HPI selama pelaksanaan ujian. Pelanggaran seperti kecurangan, penyamaran, atau tindakan mengganggu akan mengakibatkan diskualifikasi langsung dan hangusnya biaya pendaftaran.<br/>
                    <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>8. Batasan Tanggung Jawab</div>
                        HPI tidak bertanggung jawab atas kehilangan pribadi, kendala teknis, atau keadaan di luar kendali yang dapat memengaruhi kemampuan peserta untuk mengikuti ujian. HPI akan berupaya memberikan informasi terkini melalui saluran resmi.<br/>
                    <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>9. Privasi dan Penggunaan Data</div>
                        Data pribadi yang diberikan dalam proses pendaftaran akan digunakan semata-mata untuk keperluan administrasi ujian dan sertifikasi, sesuai dengan kebijakan privasi HPI dan peraturan perundang-undangan yang berlaku di Indonesia.<br/>
                    <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>10. Hukum yang Berlaku</div>
                        Syarat dan Ketentuan ini tunduk pada dan ditafsirkan sesuai dengan hukum yang berlaku di wilayah hukum Republik Indonesia.
                </Col>
            </Row>
        </Container>
    )
}

export default TSNTermsAndConditionPage
